import { render, staticRenderFns } from "./AdminBoxes.vue?vue&type=template&id=0f24602b&scoped=true"
import script from "./AdminBoxes.vue?vue&type=script&lang=js"
export * from "./AdminBoxes.vue?vue&type=script&lang=js"
import style0 from "./AdminBoxes.vue?vue&type=style&index=0&id=0f24602b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f24602b",
  null
  
)

export default component.exports